export default __webpack_public_path__ + "static/media/Suq.f8fc4bc1.png";